import { formatDate } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbDateStruct, NgbInputDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { ActorApiClient } from 'src/app/services/api-clients/actor.api-client';

@Component({
  selector: 'app-edit-data-dialog',
  templateUrl: './edit-data-dialog.component.html'
})
export class EditDataDialogComponent implements OnInit {

  minDeadline: Date = new Date(new Date().setDate(new Date().getDate() + 1));
  model: NgbDateStruct | undefined;
  startDate!: { year: number; month: number; day: number; };
  actor: any;
  originalMessage:string = "";
  documentId:string="";
  dossierId:string="";
  placeholderDate:string = "";


  constructor(config: NgbInputDatepickerConfig, private activeModal: NgbActiveModal, private actorService: ActorApiClient) {
    config.outsideDays = 'hidden';
    config.autoClose = 'outside';
    config.placement = ['bottom'];
  }

  ngOnInit(): void {
    this.originalMessage = this.actor.message;
    this.minDeadline = new Date(this.actor.deadline);

    this.placeholderDate = formatDate(this.minDeadline, "d-M-y", "en-US")
    this.startDate = { year: this.minDeadline.getFullYear(), month: this.minDeadline.getMonth() + 1, day: this.minDeadline.getDate() };
    // ngOnInit must not be empty. It's approved by a comment.
  }

  PersonChange(key:string, event:any){
    if(key != "deadline"){
      this.actor[key] = (event.target as HTMLInputElement).value;
    }
    else{
      let date = new Date
      date.setFullYear(event.year, event.month-1, event.day)
      this.actor.deadline = date;
    }
  }
  async save(){
    (await this.actorService.updateActionToPerson(this.dossierId, this.documentId, this.actor)).subscribe({
    });
    if(this.originalMessage != this.actor.message){
        (await this.actorService.updateDossierPerson(this.dossierId, this.actor)).subscribe({
        });
    }
    this.activeModal.close();
  }

  close() {
    this.activeModal.close();
  }

}
